export default axios => ({

    getList(type = 'list', payload) {
        return axios.get(`/visit/${type}`, payload);
    },
    getAllList(payload) {
        return axios.get(`/visit/list/all`, payload);
    },
    get(visitId) {
        return axios.get(`visit/${visitId}/take`);
    },
    questionnaire(visitId, payload) {
        return axios.get(`visit/${visitId}/user/questionnaire`, payload);
    },
    device(visitId) {
        return axios.get(`visit/${visitId}/device/list`);
    },
    saveVisitLightComment(visitId, payload) {
        return axios.post(`visit/${visitId}/comment`, payload);
    },
    getVisitLightComment(visitId){
        return axios.get(`visit/${visitId}/comment`);
    },
    getRecommendation(visitId) {
        return axios.get(`/visit/${visitId}/recommendation`);
    },
    postRecommendation(visitId, payload) {
        return axios.post(`/visit/${visitId}/recommendation`, payload);
    },

    getPoll(visitId, payload) {
        return axios.get(`/visit/${visitId}/poll/tag`, payload);
    },

    getQuestionnaire(visitId, payload) {
        return axios.get(`visit/${visitId}/user/questionnaire`, payload);
    },

    close(visitId, payload) {
        return axios.get(`/visit/${visitId}/release`, payload);
    },

    lite(department_id) {
        return axios.get(`visit/lite`, department_id);
    },

    saveComment(visitId, deviceId, payload) {
        return axios.post(`/visit/${visitId}/device/${deviceId}/comment`, payload);
    },
    saveConslusion(visitId, payload) {
        return axios.post(`/visit/${visitId}/conclusion`, payload);
    },

    generateConclusion(visitId, payload) {
        return axios.post(`/visit/${visitId}/conclusion/generate`, payload);
    },
    updateConclusion(visitId, payload) {
        return axios.post(`/visit/${visitId}/conclusion/update`, payload);
    },
    getListByDoctorInfo(visitId, payload) {
        return axios.get(`/visit/list-by-doctor-info`, payload);
    },
    getMlData(visitId) {
        return axios.get(`/visit/${visitId}/ml`);
    }




})
